import { Controller } from '@hotwired/stimulus'

/* global $, moment */
// Wraps the jQuery daterangepicker plugin; requires jQuery + moment loaded globally
export default class extends Controller {
  static targets = ['trigger', 'display']
  static values = { ranges: Array }

  connect() {
    if (typeof $ === 'undefined') return

    const ranges = Object.fromEntries(
      this.rangesValue.map(({ label, from, to }) => [
        label,
        [moment(from), moment(to)],
      ]),
    )

    $(this.triggerTarget).daterangepicker(
      {
        startDate: this.#startDate(),
        endDate: this.#endDate(),
        opens: 'left',
        alwaysShowCalendars: true,
        locale: { cancelLabel: 'Clear' },
        ranges,
      },
      (start, end) => this.#applyRange(start, end),
    )

    $(this.triggerTarget).on('cancel.daterangepicker', () => this.#clearRange())
  }

  disconnect() {
    const picker = $(this.triggerTarget).data('daterangepicker')
    picker?.remove()
  }

  #applyRange(start, end) {
    this.#setHidden('from_date', start.format('YYYY-MM-DD'))
    this.#setHidden('to_date', end.format('YYYY-MM-DD'))
    this.displayTarget.textContent = `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`
    this.element.requestSubmit()
  }

  #clearRange() {
    this.#setHidden('from_date', '')
    this.#setHidden('to_date', '')
    this.displayTarget.textContent = 'Select Date Range'
    this.element.requestSubmit()
  }

  #setHidden(name, value) {
    this.element.querySelector(`input[name="${name}"]`).value = value
  }

  #startDate() {
    const val = this.element.querySelector('input[name="from_date"]').value
    return val ? moment(val) : moment(this.rangesValue[0]?.from)
  }

  #endDate() {
    const val = this.element.querySelector('input[name="to_date"]').value
    return val ? moment(val) : moment(this.rangesValue[0]?.to)
  }
}
